import { render } from "./DisplayTextNode.vue?vue&type=template&id=534dcc0e"
import script from "./DisplayTextNode.vue?vue&type=script&lang=js"
export * from "./DisplayTextNode.vue?vue&type=script&lang=js"

import "./DisplayTextNode.vue?vue&type=style&index=0&id=534dcc0e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__